import LivestockIcon from './livestock-icon';
export default LivestockIcon;
